<template>
  <div>
    <NavBar />
    <router-view />
    <chat-assistant />
    <!--<ScrollToTopButton />-->
    <Footer />
  </div>
</template>

<script>
import NavBar from '../components/partials/NavBar.vue';
import Footer from '../components/partials/Footer.vue';
//import ScrollToTopButton from '../components/partials/ScrollToTopButton.vue';
import ChatAssistant from '../components/ChatAssistant.vue';

export default {
  components: {
    NavBar,
    Footer,
    ChatAssistant
  }
};
</script>